/**
 * Membership API client
 * Handles pool membership operations
 */
import type { ApiResponse, Membership, Pool } from './types';
import { apiClient } from './client';

/**
 * Join a pool using an invite code
 * @param inviteCode 8-character invite code
 * @returns Membership record
 */
export async function joinPool(
  inviteCode: string
): Promise<ApiResponse<Membership>> {
  return apiClient.post<Membership>('/pools/join', { inviteCode });
}

/**
 * Get all pools the current user is a member of
 * @returns List of pools
 */
export async function getMyPools(): Promise<ApiResponse<Pool[]>> {
  return apiClient.get<Pool[]>('/pools');
}
